import './styles/reset.css';
import './styles/fonts.css';
import './styles/typography.css';
import './styles/layout.css';
import './styles/global.css';
import './theme/colors.css';
import './theme/theme.css';
import './animations/Animation.css';
import './components/ui/Button/Button.css';
import './components/sections/Navbar/Navbar.css';
import './components/sections/Hero/Hero.css';
import './styles/auth.css';
import Router from './router/Router';

import bootstrapHome from './bootstrap/bootstrapHome';
import bootstrapProgramme from './bootstrap/bootstrapProgramme';
import ThemeManager from './theme/ThemeManager';

ThemeManager.init();
bootstrapHome();
bootstrapProgramme();
